import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import config from 'react-observable-store'
import IssuesModel from '../models/IssuesModel'
import AuthModel from '../models/AuthModel'
import { Row, Col, Icon, Table } from 'antd'
import MapLayerSwitcher from './MapLayerSwitcher'
import Gallery from './Gallery'
import moment from 'moment'

const dateFormat = 'YYYY/MM/DD HH:mm'

class SimplePublicIssue extends Component {

    constructor(props) {
        super(props)

        // Init map
        this.map = IssuesModel.createMap(config.get('globals').olmap1, props.data.mapCenter, props.data.mapZoom)

        // Init UI form state
        this.state = {
            loading: true
        }
    }

    componentDidMount() {
        const mapTarget = ReactDOM.findDOMNode(this.refs.map)
        this.map.setTarget(mapTarget)
        IssuesModel.olMap = this.map
        this.map.getView().setZoom(this.props.data.mapZoom)
        this.map.getView().setCenter(this.props.data.mapCenter)
        if (this.props.data.id) IssuesModel.putMarker(this.props.data.mapCenter, true)
        this.loading(false)
    }

    loading(toggle) {
        var state = Object.assign({}, this.state)
        state.loading = toggle
        this.setState(state)
    }

    downloadAttach(record) {
        var attachBaseUrl = IssuesModel.endpoint() + '/download'
        var url = attachBaseUrl+'/'+record.descricao+'?token=' + AuthModel.getAuthToken() + '&id='+record.id
        IssuesModel.download(record.descricao, url, record.mime)
    }

    rotateImage(record) {
        IssuesModel.rotateImage(record.id, () => {
            this.props.loadIssue(this.props.data.id)
        });
    }

    getImageUrl(record) {
        var baseUrl = config.get('globals').server.endpoint
        var url = baseUrl+'/'+record.ocorrencia_id+'/attach_a/'+record.descricao+'?t='+Math.random()
        return url;
    }

    getThumbUrl(record) {
        var baseUrl = config.get('globals').server.endpoint
        var url = baseUrl+'/'+record.ocorrencia_id+'/attach_a/thumb_'+record.descricao+'?t='+Math.random()
        return url;
    }

    onExport(format, mime) {
        this.loading(true)
        var url = IssuesModel.endpoint() + '/search/export/' + format + '?token=' + AuthModel.getAuthToken()
        url += '&id=' + this.props.data.id;
        IssuesModel.download(format, url, mime, () => {
            this.loading(false)
        })
    }

    render() {
        const columns = [
        {
            title: 'Descrição',
            dataIndex: 'descricao',
            key: 'descricao'
        },
        {
            title: 'Tipo',
            dataIndex: 'tipo_ficheiro_id',
            key: 'tipo_ficheiro_id',
            render: (text, r) => (
                <span>
                    {r.tipo_ficheiro_id === 1 ? 'Fotografia' :
                        (r.tipo_ficheiro_id === 2 ? 'Levantamento topográfico' : 'Outro')
                    }
                </span>
            )
        },
        {
            title: 'Data',
            dataIndex: 'data_referencia',
            key: 'data_referencia',
            render: (text, r) => (
                <span>
                    {r.data_referencia}
                </span>
            )
        },
        {
            title: 'Opções',
            key: 'action',
            render: (text, record) => (
                <div>
                  <a role="button" onClick={(e) => this.downloadAttach(record)}>
                      <Icon type="download" style={{color: 'green'}} />
                  </a>
                  {' '}
                  { record.tipo_ficheiro_id === 1 ? (
                      <a role="button" onClick={(e) => this.rotateImage(record)} title="Auto-rodar imagem">
                          <Icon type="reload" style={{color: 'brown'}} />
                      </a>
                  ) : null }
                </div>
            )
        }]
        let attachments = this.props.data.attachments || []; 
        attachments.map((item) => {
            item.key = item.id
            return item
        })
        var images = attachments.filter((item) => item.mime.indexOf('image') > -1)
        var galleryItems = images.map((item) => {
            return {
                original: this.getImageUrl(item),
                thumbnail: this.getThumbUrl(item)
            }
        });

        // Display not found
        if (!this.props.data.id) {
            return (
                <div>
                    <Row>
                        <Col xs={24} sm={6}></Col>
                        <Col xs={24} sm={14}><legend>Ops! Ocorrência Não Encontrada.</legend></Col>
                    </Row>
                </div>
            )
        }

        // Display issue
        return (
            <div>

                <Row>
                    <Col xs={24} sm={6}></Col>
                    <Col xs={24} sm={14}><legend>Detalhes da Ocorrência</legend></Col>
                </Row>

                <Row>
                    <Col xs={24} sm={6}></Col>
                    <Col xs={24} sm={14}>

                        <table style={{textAlign: 'left', verticalAlign: 'top'}}>
                            <tbody>
                                <tr>
                                    <th>ID do Registo</th><td>{this.props.data.id}</td>
                                </tr>
                                <tr>
                                    <th>Programa</th><td>{this.props.data.programa}</td>
                                </tr>
                                <tr>
                                    <th>Local</th><td>{this.props.data.address}</td>
                                </tr>
                                <tr>
                                    <th>Freguesia</th><td>{this.props.data.freguesia}</td>
                                </tr>
                                <tr>
                                    <th>Concelho</th><td>{this.props.data.concelho}</td>
                                </tr>
                                <tr>
                                    <th>Distrito</th><td>{this.props.data.distrito}</td>
                                </tr>
                                <tr>
                                    <th>ARH</th><td>{this.props.data.arh}</td>
                                </tr>
                                <tr>
                                    <th>Data da Ocorrência</th>
                                    { this.props.data.data_ocorrencia_tipo === 0 ? (
                                      <td>{moment(this.props.data.data_ocorrencia).format(dateFormat)}</td>
                                    ) : (
                                        <td><em>Indeterminada</em></td>
                                    ) }
                                </tr>
                                <tr>
                                    <th>Data do Registo</th><td>{moment(this.props.data.data_registo_local).format(dateFormat)}</td>
                                </tr>

                                { this.props.data.id ? (
                                    <tr>
                                        <th>Data do Registo no Sistema</th>
                                        <td>{moment(this.props.data.data_registo).format(dateFormat)}</td>
                                    </tr>
                                ) : null}

                                <tr>
                                    <th>Email</th><td>{this.props.data.email}</td>
                                </tr>

                                { this.props.data.obs ? (
                                    <tr>
                                        <th>Observações</th>
                                        <td>{this.props.data.obs}</td>
                                    </tr>
                                ) : null }

                            </tbody>
                        </table>

                        <div className="map" id="map" ref="map" style={{height: '252px', marginTop: '24px', marginBottom: '24px'}}>
                            <MapLayerSwitcher map={this.map} />
                        </div>

                        <div id="attachments">
                            <legend>Anexos</legend>
                            <Table dataSource={attachments} columns={columns} />
                        </div>

                        { galleryItems.length ? (
                            <Gallery items={galleryItems} />
                        ) : null }

                    </Col>
                </Row>

            </div>
        )
    }
}

export default SimplePublicIssue;



// WEBPACK FOOTER //
// ./src/components/SimplePublicIssue.js